// extracted by css-extract-rspack-plugin
export default {"cls1":"add_paper_to_work_collection_modal-wjs-cls1_D6-","cls2":"add_paper_to_work_collection_modal-wjs-cls2_gsp add_paper_to_work_collection_modal-wjs-cls1_D6-"};